<script setup lang="ts">
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import type { Elemental } from '~~/src/types/elemental'
import { useFavorite } from '~~/src/composables/useFavorite'

const props = defineProps<{
  elemental: Elemental
}>()

const { favorite, isPending } = useFavorite(props.elemental)

const isFavorite = ref(props.elemental.isFavorite ?? false)

const handleFavorite = () => {
  favorite(isFavorite.value)
  isFavorite.value = !isFavorite.value
}

watch(() => props.elemental.isFavorite, (newValue) => {
  isFavorite.value = newValue ?? false
})
</script>

<template>
  <DropdownMenuItem :disabled="isPending" class="flex items-center gap-2" @select="handleFavorite">
    <div v-if="isFavorite" i-mdi:star class="w-3 h-3" />
    <div v-else i-mdi:star-outline class="w-3 h-3" />
    <span>
      {{ isFavorite ? 'Remove Favorite' : 'Add Favorite' }}
    </span>
  </DropdownMenuItem>
</template>
